import { type Breakpoint, Stack, type StackProps, useMediaQuery, useTheme } from "@mui/material";
import type { Key, ReactNode } from "react";
import { ResponsiveTabsFull } from "./fullTabs";
import { ResponsiveTabsReduced } from "./reducedTabs";

export interface IResponsiveTabsProps<Value extends Key, Tab> {
  breakpoint: Breakpoint | number;
  tabs: readonly Tab[];
  value: Value;
  getLabel: (tab: Tab) => ReactNode;
  getValue: (tab: Tab) => Value;
  onChange: (value: Value) => void;
  renderTab: (tab: Tab, onClick: () => void, selected: boolean) => ReactNode;
  slotProps?: {
    stack?: Partial<StackProps>;
  };
}

export const ResponsiveTabs = <Value extends Key, Tab>({
  breakpoint,
  tabs,
  value,
  getLabel,
  getValue,
  onChange,
  renderTab,
  slotProps,
}: IResponsiveTabsProps<Value, Tab>) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      {...slotProps?.stack}
      sx={{
        gap: 1,
        alignItems: "center",
        overflow: "auto",
      }}
    >
      {useMediaQuery(theme.breakpoints.up(breakpoint)) ? (
        <ResponsiveTabsFull tabs={tabs} value={value} getValue={getValue} onChange={onChange} renderTab={renderTab} />
      ) : (
        <ResponsiveTabsReduced
          tabs={tabs}
          value={value}
          getLabel={getLabel}
          getValue={getValue}
          onChange={onChange}
          renderTab={renderTab}
        />
      )}
    </Stack>
  );
};
